var n="<anonymous>";function t(t){try{return t&&"function"==typeof t&&t.name||n}catch(t){return n}}export{t as getFunctionName};
